import io from 'socket.io-client'

const baseURL = `${process.env.REACT_APP_API_URL}/v1/socket`

console.log('baseURL-Socket', baseURL)
export const socket = io(`${baseURL}`)
